import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Container, Jumbotron } from 'reactstrap';

export default class Error extends PureComponent {
  render() {
    const { errorMessage } = this.props;
    return (
      <Container>
        <br />
        <br />
        <Jumbotron>
          <h1 className="display-3">Oh No!</h1>
          <p className="lead">Something went wrong</p>
          <hr className="my-2" />
          <p>{errorMessage}</p>
          {/* <p className="lead">
            <Button color="primary">Go Back</Button>
          </p> */}
        </Jumbotron>
      </Container>
    );
  }
}

Error.propTypes = {
  errorMessage: PropTypes.string,
};

Error.defaultProps = {
  errorMessage: '',
};



// WEBPACK FOOTER //
// ./src/containers/Error/index.js